var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{style:(_vm.activeSystem==''?'display:none':'')},[_c('a',{staticClass:"btn bt-lg toggler",attrs:{"id":"wt-toggler"},on:{"click":_vm.changeLayout}},[_c('i',{staticClass:"fa fa-lg fa-bars"})])])}
var staticRenderFns = []

export { render, staticRenderFns }